export default __webpack_public_path__ + "static/media/workshop.464e20da.jpg";